import { render, staticRenderFns } from "./client.vue?vue&type=template&id=4058eb5e&"
import script from "./client.vue?vue&type=script&lang=ts&"
export * from "./client.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports